import EcoSection from 'eco-design/base/eco-section';
import styles from './index.module.scss';
import EFPicture from '@elem/compCommon/EFPicture';

export type SectionProProps = { label?: string; title?: string; desc?: string; children: any; className?: string };

const SectionPro: React.FC<SectionProProps> = (props: SectionProProps) => {
    return (
        <div
            className={styles.SectionPro + (props.className ? ` ${props.className}` : '') + ' GtmModuleData-section'}
            data-section-id={styles.SectionPro}
            data-section-title={props.title}
        >
            <EcoSection title={props.title} desc={props.desc} label={props.label} titleColor="#000" descColor="#707070" labelColor="#3F68E0" />
            {props.children}
        </div>
    );
};

export default SectionPro;
